export default function (number, maxDigits, maxDecimal) {
    var humanReadableExtensions = [ '', 'k', 'm', 'b', 't' ]

    var magnitude = Math.floor((Math.floor(number).toString().length - 1) / 3)
    var leadingDigits = (Math.floor(number).toString().length - 1) % 3 + 1
    var decPlaces = Math.pow(10, (Math.min(maxDigits - leadingDigits, maxDecimal || maxDigits - leadingDigits)))

    number = Math.round(number * decPlaces / Math.pow(10, magnitude * 3)) / decPlaces

    return number + humanReadableExtensions[magnitude]
}



// WEBPACK FOOTER //
// ./src/plugins/HumanReadableNumbers.js